async function loadReactDom () {
    const {
        createPortal,
    } = await import('react-dom');

    return createPortal;
}
export default loadReactDom;


